import { render, staticRenderFns } from "./TaxRateForm.vue?vue&type=template&id=1dea5484&"
import script from "./TaxRateForm.vue?vue&type=script&lang=js&"
export * from "./TaxRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports